require('../../modules/es.typed-array.reduce');



//////////////////
// WEBPACK FOOTER
// ./node_modules/jspdf/node_modules/core-js/es/typed-array/reduce.js
// module id = +MU2
// module chunks = 3